/**
 * Clean url query from ltn and utm_*
 * e.g. ?foo=1&ltn=2 →  ?foo=1
 */
export const replaceQuery = (query: string): string =>
  query.replace(/[&?]ltn=?[^&=]*/g, '').replace(/^&/, '?')

/*
 * Removing utm_* disabled until ga('set', ...) will be added, coz if cut utm from url they won't be added to ga.
 *
 * https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#campaignMedium
 *
 * utm_source: Identify the advertiser, site, publication, etc. that is sending traffic to your property,
 * for example: google, newsletter4, billboard.
 * *ga(‘set’, ‘campaignSource’, ‘(direct)’);*
 *
 * utm_medium: The advertising or marketing medium, for example: cpc, banner, email newsletter.
 * *ga(‘set’, ‘campaignMedium’, ‘organic’);*
 *
 * utm_campaign: The individual campaign name, slogan, promo code, etc. for a product.
 * *ga(‘set’, ‘campaignName’, ’(direct)’);*
 *
 * utm_term: Identify paid search keywords. If you’re manually tagging paid keyword campaigns, you should also use
 * utm_term to specify the keyword.
 *
 * utm_content: Used to differentiate similar content, or links within the same ad. For example, if you have two
 * call-to-action links within the same email message, you can use utm_content and set different values for each
 * so you can tell which version is more effective.
 * *ga(‘set’, ‘campaignContent’, ‘content’);*
 */
const cleanQueryParams = (): void => {
  // const query = window.location.search.replace(/[&?](ltn|utm_[^&=]+)=?[^&]?/g, '').replace(/^&/, '?')

  const query  = replaceQuery(window.location.search)
  const url    = window.location.origin + window.location.pathname + query

  window.history.replaceState({}, document.title, url)
}


export default cleanQueryParams
